import { Controller } from "@hotwired/stimulus"
import Handlebars from "handlebars"
import BaseGrid, { html } from "../utils/base_grid"

const bookTemplate = Handlebars.compile(`
  <strong>{{name}}</strong>
  {{#if abbreviation}}
    <br><code class="small">{{abbreviation}}</code>
  {{/if}}
`)

const languageBadgeTemplate = Handlebars.compile(`
  <span class="badge">{{#if (eq language 'de')}}🇩🇪 {{germanLabel}}{{else}}🇬🇧 {{englishLabel}}{{/if}}</span>
`)

const actionsTemplate = Handlebars.compile(`
  <a href="{{compare_url}}" class="btn btn-primary btn-sm" data-bs-title="{{compareLabel}}" data-bs-toggle="tooltip">
    <i class="fa-solid fa-code-compare"></i>
  </a>
`)

Handlebars.registerHelper('eq', function (a, b) {
  return a === b;
});

export default class extends Controller {
  static values = { url: String, translations: Object }
  static targets = ["container", "skeleton"]

  connect() {
    const t = this.translationsValue || {}
    
    this.baseGrid = new BaseGrid(this, {
      limit: 20,
      search: true,
      columns: [
        { 
          name: t.book || "Book", 
          formatter: (cell, row) => html(bookTemplate(row.cells[0].data))
        },
        { 
          name: t.language || "Language", 
          formatter: (cell, row) => {
            const data = {
              ...row.cells[0].data,
              germanLabel: t.german || "German",
              englishLabel: t.english || "English"
            }
            return html(languageBadgeTemplate(data))
          }
        },
        { 
          name: t.contents || "Contents",
          id: "contents_count"
        },
        { 
          name: t.last_updated || "Last Updated", 
          id: "updated_at",
          formatter: (cell) => new Date(cell).toLocaleDateString()
        },
        { 
          name: t.actions || "Actions", 
          sort: false,
          formatter: (cell, row) => {
            const data = {
              ...row.cells[0].data,
              compareLabel: t.compare || "Compare"
            }
            return html(actionsTemplate(data))
          }
        }
      ],
      mapData: (book) => [
        book, 
        book, 
        book.contents_count,
        book.updated_at,
        null
      ],
      language: {
        search: {
          placeholder: t.search || "Search..."
        },
        pagination: {
          previous: t.prev || "Previous",
          next: t.next || "Next",
          showing: t.showing || "Showing",
          of: t.of || "of",
          to: t.to || "to",
          results: t.results || "results"
        },
        loading: t.loading || "Loading...",
        noRecordsFound: t.no_results || "No matching records found",
        error: t.error || "An error happened while fetching the data"
      }
    })
    
    this.grid = this.baseGrid.create()
  }

  disconnect() {
    this.baseGrid.destroy()
  }
}
